import _ from 'lodash';

import { adminClient as apolloClient } from '@/store/apollo';

import InfoBoardContentsGql from '@/store/graphql/system/queries/InfoBoardContents.gql';
import SaveInfoBoardContentGql from '@/store/graphql/system/mutations/SaveInfoBoardContent.gql';
import DeleteInfoBoardContentGql from '@/store/graphql/system/mutations/DeleteInfoBoardContent.gql';

export default {
    fetchAll: function (cmsId) {
        if (cmsId === undefined) throw new Error('required argument cmsId is missing');

        return new Promise(function (resolve, reject) {
            apolloClient
                .query({
                    query: InfoBoardContentsGql,
                    variables: { cms_id: parseInt(cmsId) },
                    fetchPolicy: 'network-only'
                })
                .then(function (result) { resolve(result.data.InfoBoardContents); })
                .catch(function (error) { reject(error); });
        });
    },
    save: function (cmsId, input) {
        if (cmsId === undefined) throw new Error('required argument cmsId is missing');
        if (input === undefined) throw new Error('required argument input is missing');

        input = _.removeDeepByKey(input, '__typename');

        return new Promise(function (resolve, reject) {
            apolloClient
                .mutate({
                    mutation: SaveInfoBoardContentGql,
                    variables: {
                        cms_id: parseInt(cmsId),
                        input: input
                    }
                })
                .then(function (result) {
                    apolloClient.clearStore();
                    resolve(result.data.SaveInfoBoardContent);
                })
                .catch(function (error) { reject(error); });
        });
    },
    remove: function (id, cmsId) {
        if (id === undefined) throw new Error('required argument id is missing');
        if (cmsId === undefined) throw new Error('required argument cmsId is missing');

        return new Promise(function (resolve, reject) {
            apolloClient
                .mutate({
                    mutation: DeleteInfoBoardContentGql,
                    variables: {
                        id: parseInt(id),
                        cms_id: parseInt(cmsId)
                    }
                })
                .then(function (result) {
                    apolloClient.clearStore();
                    resolve(result.data.DeleteInfoBoardContent);
                })
                .catch(function (error) { reject(error); });
        });
    }
};
